import { userManagementApis } from '@shared/apis';
import { genericMutation, genericMutationWithId, genericQueryWithParams } from './generics';

export const useStartMentorPersonalDataExport =
  genericMutationWithId<userManagementApis.StartMentorPersonalDataExport>(
    userManagementApis.startMentorPersonalDataExport
  );

export const useStartStudentPersonalDataExport =
  genericMutationWithId<userManagementApis.StartStudentPersonalDataExport>(
    userManagementApis.startStudentPersonalDataExport
  );

export const useStartParentPersonalDataExport =
  genericMutationWithId<userManagementApis.StartParentPersonalDataExport>(
    userManagementApis.startParentPersonalDataExport
  );

export const useSetActiveStatus = genericMutation<userManagementApis.SetActiveStatus>(
  userManagementApis.setActiveStatus
);

export const useSyncUserWithAuth0 = genericMutationWithId<userManagementApis.SyncUserWithAuth0>(
  userManagementApis.syncUserWithAuth0
);

export const useChangeUserTestState = genericMutation<userManagementApis.ChangeUserTestState>(
  userManagementApis.changeUserTestState
);

export const useSendActivationLink = genericMutation<userManagementApis.SendActivationLink>(
  userManagementApis.sendActivationLink
);

export const useCheckDriveStatus = genericQueryWithParams<userManagementApis.CheckDriveStatus>(
  userManagementApis.checkDriveStatus
);
